export default "__VITE_ASSET__929cf7d9__"